export const LoadingSection = () => ({
  zIndex: 20,
});